import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {message, Popover, Tag } from "antd"
import className from "classnames"
import Marketplace from "../../../home/components/orders/data/Marketplace"
import OrderMockUp from "../../../home/components/orders/data/OrderMockUp"
import ItemType from "../../../home/components/orders/data/ItemType"
import ItemSize from "../../../home/components/orders/data/ItemSize"
import ItemStatus from "../../../home/components/orders/data/ItemStatus"
import ItemImage from "../data/ItemImage"
import showDateTime from "../../../shared/ShowDateTime"
import convertDateOverTime from '../../../../helpers/convertDateOverTime'

class BatchItem extends Component {
    constructor(props) {
        super(props)

        const { item} = this.props.order
        const {production_status} = item
        const itemStatus = item.hasOwnProperty('sub_status') ? item.sub_status : production_status

        this.state = {
            productionStatus: itemStatus,
            visible: false
        }
    }

    _changeStatus = value => {
        this.setState({
            status: value,
        }, () => {
            message.success('Trạng thái đã thay đổi')
        })
    }

    render() {
        const {order, reloadItems, statusBatch} = this.props
        const {error_type, status, failed_pieces, _id: batchItemId, product_type} = order
        const {_id, marketplace, size, type, image, item_number, total_item, preview_image, safezone_image, partials, meta, embroidery_area_info} = order.item
        const {mock_up_front, mock_up_back, basket_number, namespace, is_archive, overtime, tags} = order.item
        const failedPirces = !!partials && partials.filter(piece => failed_pieces.includes(piece.name)).map(item => ({
            name : item.name,
            image : item.image,
            preview : item.preview
        }))

        const show_file_in = (preview) => (
            <div className='Preview position-relative'>
                <img src={preview} className='position-absolute' alt='preview'/>
            </div>
        )
        const {productionStatus} = this.state
        const overtimeText = !!overtime ? convertDateOverTime(overtime) : '-'
        return (
            <tr  
                className={className('OrderItem', {
                    'Printed': productionStatus === 'printed',
                    'ErrorQC': !!error_type
                })}
            >
                <Marketplace namespace={namespace} basketNumber={basket_number} marketplace={marketplace}
                             itemNumber={item_number}
                             totalItems={total_item} size={size} productionStatus={productionStatus} tags={tags} lazyload={false}/>
                <OrderMockUp mockUpFront={mock_up_front} mockUpBack={mock_up_back} orderId={_id} lazyload={false}/>
                <ItemType type={type} brand={order.brand} lazyload={false}/>
                <ItemSize size={size} lazyload={false}/>
                <ItemImage
                    image={image}
                    previewImage={preview_image}
                    orderId={_id} status={status}
                    type={type}
                    size={size}
                    safezoneImage={safezone_image}
                    onChangeStatus={this._changeStatus}
                    reloadItems={reloadItems}
                    batchItemId={batchItemId}
                    meta={meta}
                    embroidery_area_info={embroidery_area_info}
                    statusBatch={statusBatch}
                    productType={product_type}
                />
                <td>
                    <div className='FileIn'>
                        {
                            !!failedPirces ? failedPirces.map(item=> (
                                <Popover 
                                    content={show_file_in(item.preview)}
                                >
                                    <Tag color="#f50" className='text-center'>
                                        <a href={item.image} target="_blank" className='cursor-pointer d-inline-block'>{item.name}</a>
                                    </Tag>
                                </Popover>
                            )) : '-'
                        }
                    </div>
                </td>
                <td className='OverTime d-flex align-items-center'>
                    {overtime > 0 && 
                        <label 
                            className='btn btn-sm mr-1 mb-0' 
                            style={{
                                background: 'rgb(255 77 80)', 
                                color:'white',
                            }}
                        >
                            Quá hạn
                        </label>
                    }
                    <span className={`mb-0 ${overtime > 0 ? 'text-danger' : ''}`}>{overtimeText}</span>
                </td>
                <td className='UploadTime'>{showDateTime(order.confirmed_at)}</td>
                <td className='UploadTime'>{showDateTime(order.completed_at)}</td>
                <ItemStatus is_archive={is_archive} status={status} lazyload={false}/>
            </tr>
        )
    }
}

BatchItem.propTypes = {
    order: PropTypes.object.isRequired
}

export default BatchItem
